import getApi from '../../api/apisauceConfig'
import { AudiometerInstance } from '../../model/Audiometry'
import { deserializeAudiometerInstanceResponse } from './mapper'

export const getAudiometerInstance = (id: number, signal?: AbortSignal) =>
  getApi()
    .get<AudiometerInstance>(`/audiometry/audiometer_instances/${id}`, { signal })
    .then(deserializeAudiometerInstanceResponse)
